import React, { useEffect } from "react";

import { AppLoader } from "../../common/components/AppLoader";

interface LoginRedirectProps {
    onLogin(): void;
}

export const LoginRedirect: React.FunctionComponent<LoginRedirectProps> = (props: LoginRedirectProps) => {
    useEffect(() => {
        props.onLogin();
    }, []);

    return <AppLoader message="Redirecting to login page..." />;
};
